<template>

    <div>

        <header-green v-if="!isNativeUser"></header-green>

        <div class="cookies__container">

            <article class="cookies__content" v-html="html"></article>

        </div>

        <footer-green v-if="!isNativeUser"></footer-green>

    </div>

</template>

<script>

import Vuex from 'vuex'

import I18n from '@/modules/i18n'
import UserFlow from '@/modules/userFlow'

import HeaderGreen from '@/components/headers/HeaderGreen'
import FooterGreen from '@/components/FooterGreen'

export default {

    name: 'about',

    components: {HeaderGreen, FooterGreen},

    watch: {

        lang: function () {
            this.loadContent()
        }

    },

    computed: {

        ...Vuex.mapGetters(['lang']),

        isNativeUser: function () {
            return this.$route.path.indexOf('/native/') > -1
        }

    },

    data() {
        return {
            html: ''
        }
    },

    created() {
        UserFlow.setPage(this, 'cookies-policy')
    },

    mounted() {

        this.loadContent()

    },

    methods: {

        loadContent() {

            this.$http.get(`/static/cookies-policy/${I18n.get(this)}.html`)
                .then(response => {
                    this.html = response.data
                })
        }

    }
}
</script>

<style lang="scss" scoped>

.cookies {
    &__container {
        padding: 90px 20px 65px;
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (min-width: $above-mobile-length) {
            padding: 144px 24px 128px;
        }
    }

    &__content {
        max-width: 644px;
    }
}
</style>
